'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rootUrl = exports.defaultTitle = undefined;
exports.moduleUrl = moduleUrl;
exports.entryUrl = entryUrl;

var _path = require('path');

var defaultTitle = exports.defaultTitle = 'API Documentation';
var rootUrl = exports.rootUrl = function rootUrl(apiDocs) {
    return apiDocs.url || '/docs';
};
function moduleUrl(module, apiDocs) {
    return apiDocs.data.mainModule === module.outPath ? rootUrl(apiDocs) : (0, _path.join)(rootUrl(apiDocs), module.outPath);
}
function entryUrl(declaration, module, apiDocs) {
    if (declaration.reexport) {
        module = apiDocs.data.modules[declaration.reexport.path];
    }
    var taggedDeclaration = module.declarations[declaration.id];
    var kind = taggedDeclaration.kind.toLowerCase();
    return (0, _path.join)(moduleUrl(module, apiDocs), kind + '.' + declaration.name);
}
//# sourceMappingURL=urls.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/lib/urls.js